import { render } from "./BusinessDetailsForm.vue?vue&type=template&id=2407cad8&ts=true"
import script from "./BusinessDetailsForm.vue?vue&type=script&lang=ts"
export * from "./BusinessDetailsForm.vue?vue&type=script&lang=ts"

import "./BusinessDetailsForm.vue?vue&type=style&index=0&id=2407cad8&lang=css"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__